import { api } from "@/lib/api";

export const IMAGE_EXT = new Set(["jpg", "jpeg", "png"]);
export const MODEL_EXT = new Set(["stl", "3mf", "obj", "gltf", "glb", "step", "stp"]);
export const CAD_EXT = MODEL_EXT;
export const MAX_BYTES = 100 * 1024 * 1024;
export const ACCEPT = ".stl,.step,.stp,.3mf,.obj,.pdf,.jpg,.jpeg,.png,.gltf,.glb";

export const KIND_LABEL = {
  kundendatei: "Kundendatei",
  arbeitsdatei: "Arbeitsdatei",
  cad_quelle: "CAD-Quelle",
  druckdatei: "Druckdatei",
  vorschau: "Vorschau",
};

export const fmtSize = (n) => {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1).replace(".", ",")} kB`;
  return `${(n / 1024 / 1024).toFixed(1).replace(".", ",")} MB`;
};

// Art der In-App-Vorschau je Dateiendung
export const previewType = (ext) => {
  const e = (ext || "").toLowerCase();
  if (IMAGE_EXT.has(e)) return "image";
  if (e === "pdf") return "pdf";
  if (MODEL_EXT.has(e)) return "model";
  return "none";
};

export const fetchFileBlob = async (att) => {
  const r = await api.get(`/attachments/${att.id}/download`, { responseType: "blob" });
  return r.data;
};

export const downloadFile = async (att) => {
  const blob = await fetchFileBlob(att);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = att.original_name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

// Hinweis-Text für Uploads, bei denen identische Inhalte nur verknüpft wurden
export const uploadMessage = (name, data) => {
  if (data?.linked_existing) return `${name}: identische Datei ist bereits vorhanden – nicht erneut gespeichert.`;
  if (data?.reused_blob) return `${name}: Datei war bereits beim Kunden gespeichert – verknüpft, keine Kopie angelegt.`;
  return `${name} hochgeladen.`;
};
